"use strict";
import React from "react";
import Api from "../../api/api";
import ExtractedFields from "../factoring/extracted_fields";
import ExtractedFieldVisibility from "./extracted_field_visibility";
import InvoiceExpectedAmount from "./invoice_expected_amount";
import LinkedStateMixin from "react-addons-linked-state-mixin";
import moment from "moment";
import PossibleAdjustments from "./possible_adjustments";
import ValueLinkTextDroppableInput from "../value_link_text_droppable_input";
import generalFormatter from "../../formatters/general";
import quickpayHelper from "../../helpers/quickpay";
import lineItemsForCalculation from "../data/line_items_for_calculation";
import TextDroppableInput from "../text_droppable_input";
import _ from "underscore";
const DocumentInformation = React.createClass({
  mixins: [LinkedStateMixin],
  getInitialState: function() {
    return this.stateFromProps(this.props);
  },
  stateFromProps: function(props) {
    const invoice = props.carrierInvoice;
    return {
      customer: props.load.load.customer,
      source_invoice_number: props.source_invoice_number,
      source_invoice_amount: props.source_invoice_amount,
      source_invoice_date: props.source_invoice_date,
      invoice_disposition: props.invoice_disposition,
      showingNoteField: false,
      forceShowInvoiceInformation: false,
      extracted_fields: invoice ? invoice.extracted_fields : {}
    };
  },
  componentWillReceiveProps: function(newProps) {
    if (newProps.carrierInvoice.id !== this.props.carrierInvoice.id) {
      this.setState(this.stateFromProps(newProps));
    }
  },
  render: function() {
    if (this.props.showInternalNoteV3Reskin) {
      return this.possibleNoteFieldV3Reskin();
    } else if (this.props.v3ReskinEnabled) {
      return this.documentInformationSectionV3Reskin();
    } else {
      return /* @__PURE__ */ React.createElement("div", { "data-component": "DocumentInformation" }, this.possibleNoteField(), /* @__PURE__ */ React.createElement("h3", { className: "load-detail__section-header" }), this.documentInformationSection());
    }
  },
  documentInformationSection: function() {
    if (this.shouldHideInformationSection()) {
      return this.showInformationSectionButton();
    } else {
      return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { className: "load-detail__quickpay-select-container" }, this.possibleQuickpaySelect(true)), /* @__PURE__ */ React.createElement("div", { className: "load-detail__document-information" }, /* @__PURE__ */ React.createElement("div", { className: "load-detail__document-information-item" }, /* @__PURE__ */ React.createElement("div", { className: "load-detail__invoice-document-info-label" }, /* @__PURE__ */ React.createElement("label", null, "Invoice Amount"), this.possibleQuickpaySelect(false)), /* @__PURE__ */ React.createElement("div", { className: "row collapse" }, /* @__PURE__ */ React.createElement("div", { className: "small-1 columns" }, /* @__PURE__ */ React.createElement("span", { className: "prefix" }, "$")), /* @__PURE__ */ React.createElement("div", { className: "small-9 columns" }, this.invoiceInput(
        "source_invoice_amount",
        "Total Charge",
        "text",
        "amount"
      ), this.possiblePossibleAdjustments()))), this.possibleExpectedAmount(), /* @__PURE__ */ React.createElement("div", { className: "load-detail__document-information-item" }, /* @__PURE__ */ React.createElement("div", { className: "load-detail__invoice-document-info-label" }, /* @__PURE__ */ React.createElement("label", null, "Invoice Number"), this.possibleInvoiceDisposition()), /* @__PURE__ */ React.createElement("span", { className: "load-detail__invoice-document-info-input-and-note-wrapper" }, this.cleanedInvoiceNumberIfDifferent(), this.invoiceInput(
        "source_invoice_number",
        "Invoice Number",
        "text"
      ))), /* @__PURE__ */ React.createElement("div", { className: "load-detail__document-information-item" }, /* @__PURE__ */ React.createElement("div", { className: "load-detail__invoice-document-info-label" }, /* @__PURE__ */ React.createElement("label", null, "Invoice Date")), /* @__PURE__ */ React.createElement("div", { className: "row collapse" }, /* @__PURE__ */ React.createElement("div", { className: "small-7 columns" }, this.dateDroppableInvoiceInput(
        "source_invoice_date",
        "Invoice Date"
      )), /* @__PURE__ */ React.createElement("div", { className: "small-3 columns" }, /* @__PURE__ */ React.createElement(
        "a",
        {
          onClick: this.setInvoiceDateToToday,
          className: "load-detail__today-button expand",
          disabled: this.props.readOnly
        },
        "Today"
      ))))), this.possibleExtractedFields());
    }
  },
  documentInformationSectionV3Reskin: function() {
    if (this.shouldHideInformationSection()) {
      return this.showInformationSectionButton();
    } else {
      const infoItem = ({ title, inputEl, showCurrency = false }) => {
        let currencyUnit, inputClass, dataLeadingText;
        if (showCurrency) {
          currencyUnit = "USD";
          inputClass = "v3__input-wrapper--has-leading-text";
          dataLeadingText = "$";
        }
        return /* @__PURE__ */ React.createElement(
          "label",
          {
            className: "v3__input-label",
            style: {
              display: "flex",
              flexDirection: "column",
              gap: "var(--space-xxxs)"
            }
          },
          /* @__PURE__ */ React.createElement(
            "div",
            {
              className: "v3__input-label-text",
              style: { display: "flex", justifyContent: "space-between" }
            },
            /* @__PURE__ */ React.createElement("span", null, title),
            /* @__PURE__ */ React.createElement(
              "span",
              {
                className: "v3__type__extra-small-body",
                style: { color: "var(--color-grayscale-600)" }
              },
              currencyUnit
            )
          ),
          /* @__PURE__ */ React.createElement(
            "div",
            {
              className: `v3__input-wrapper ${inputClass}`,
              style: { fontSize: "16px" },
              "data-leading-text": dataLeadingText
            },
            inputEl
          )
        );
      };
      const rowPairs = [
        [
          infoItem({
            title: "Invoice amount",
            inputEl: this.invoiceInput(
              "source_invoice_amount",
              "Total Charge",
              "text",
              "amount",
              true
            ),
            showCurrency: true
          }),
          infoItem({
            title: "Invoice number",
            inputEl: this.invoiceInput(
              "source_invoice_number",
              "Invoice Number",
              "text"
            )
          })
        ]
      ];
      return /* @__PURE__ */ React.createElement(
        "div",
        {
          style: {
            display: "flex",
            flexDirection: "column",
            gap: "var(--space-xs)"
          }
        },
        /* @__PURE__ */ React.createElement("h3", null, "Invoice details"),
        rowPairs.map((pair) => /* @__PURE__ */ React.createElement(
          "div",
          {
            style: {
              display: "flex",
              gap: "var(--space-s)"
            }
          },
          /* @__PURE__ */ React.createElement("div", { style: { flex: "1" } }, pair[0]),
          /* @__PURE__ */ React.createElement("div", { style: { flex: "1" } }, pair[1])
        ))
      );
    }
  },
  possibleInvoiceDisposition: function() {
    const account = Api.Account.current();
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        className: "load-detail__invoice-disposition-select",
        style: { display: account.tms === "3Gtms" ? "block" : "none" }
      },
      /* @__PURE__ */ React.createElement(
        "select",
        {
          onChange: this.handleInvoiceDispositionChange,
          value: this.state.invoice_disposition
        },
        /* @__PURE__ */ React.createElement("option", { value: "original_invoice" }, "Original invoice"),
        /* @__PURE__ */ React.createElement("option", { value: "supplemental_invoice" }, "Supplemental invoice")
      )
    );
  },
  possibleExpectedAmount: function() {
    if (this.props.load.load.source_system !== "hubtran") {
      return /* @__PURE__ */ React.createElement("div", { className: "load-detail__document-information-item" }, /* @__PURE__ */ React.createElement(
        InvoiceExpectedAmount,
        {
          sourceInvoiceAmount: this.props.source_invoice_amount,
          expectedTotal: this.tmsTotal(),
          quickpayDiscountAmount: this.quickpayDiscountAmount(),
          useCarrierCharge: this.accountSettings().always_use_carrier_charge_for_expected_amount,
          carrierInvoice: this.props.carrierInvoice,
          load: this.props.load
        }
      ));
    }
  },
  cleanedInvoiceNumberIfDifferent: function() {
    if (!this.props.cleanedSourceInvoiceNumber || !this.props.carrierInvoice) {
      return;
    }
    if (this.props.cleanedSourceInvoiceNumber != this.props.carrierInvoice.source_invoice_number) {
      return /* @__PURE__ */ React.createElement("div", { className: "load-detail__invoice-document-info-note" }, "Your TMS will be sent ", this.props.cleanedSourceInvoiceNumber);
    }
  },
  shouldHideInformationSection: function() {
    return this.props.carrierInvoice.using_implicit_carrier_invoice && !this.state.forceShowInvoiceInformation;
  },
  showInformationSectionButton: function() {
    const component = this;
    return /* @__PURE__ */ React.createElement("div", { className: "load-detail__manual-details" }, "Payment Amount copied from expected due to no invoice document.", " ", /* @__PURE__ */ React.createElement(
      "a",
      {
        onClick: () => {
          component.setState({ forceShowInvoiceInformation: true });
        }
      },
      "Enter Invoice Details Manually ..."
    ));
  },
  noteKeyPressNotifier: function(event) {
    this.props.noteFieldChanged(event.target.value);
  },
  showNotesField: function() {
    return this.props.showNoteFieldByDefault || this.state.showingNoteField || !_.isEmpty(this.props.currentNote);
  },
  possibleNoteField: function() {
    const component = this;
    if (this.props.readOnly) {
      return "";
    }
    if (this.showNotesField()) {
      return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("h3", { className: "load-detail__section-header" }, "Add an Internal Note"), /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(
        "textarea",
        {
          className: "load-detail__textarea",
          placeholder: this.notePlaceholder(),
          onChange: this.noteKeyPressNotifier
        }
      )));
    }
    return /* @__PURE__ */ React.createElement("p", null, /* @__PURE__ */ React.createElement(
      "a",
      {
        className: "load-detail__link",
        onClick: () => {
          component.setState({ showingNoteField: true });
        }
      },
      "Add an Internal Note"
    ));
  },
  possibleNoteFieldV3Reskin: function() {
    if (this.props.readOnly) {
      return null;
    }
    if (this.showNotesField()) {
      return /* @__PURE__ */ React.createElement(
        "div",
        {
          style: {
            display: "flex",
            flexDirection: "column",
            gap: "4px"
          }
        },
        /* @__PURE__ */ React.createElement("div", { className: "v3__type__extra-small-body-semi-bold" }, "Internal note"),
        /* @__PURE__ */ React.createElement(
          "textarea",
          {
            className: "v3__input",
            style: { height: "64px" },
            placeholder: this.notePlaceholder() || "Add a note",
            onChange: this.noteKeyPressNotifier
          }
        )
      );
    }
    return /* @__PURE__ */ React.createElement(
      "a",
      {
        className: "v3__type__extra-small-body-semi-bold",
        onClick: () => {
          this.setState({ showingNoteField: true });
        }
      },
      "Add internal note"
    );
  },
  notePlaceholder: function() {
    if (this.props.showNoteFieldByDefault) {
      return "Please give a reason why rules were ignored";
    }
  },
  possibleQuickpaySelect: function(forReskin) {
    if (this.accountSettings().quickpayDiscount && this.quickpayWouldBeGreaterThanZero() && !this.props.readOnly) {
      const className = forReskin ? "show_for_reskin" : "show_for_non_reskin";
      return /* @__PURE__ */ React.createElement(
        "select",
        {
          className: "load-detail__quickpay-select " + className,
          onChange: this.handleQuickpayChange,
          value: this.quickpayDisposition()
        },
        /* @__PURE__ */ React.createElement("option", { value: "not_quickpay" }, " Not QuickPay"),
        /* @__PURE__ */ React.createElement("option", { value: "applied_to_invoice" }, " ", "Invoice total includes QuickPay discount"),
        /* @__PURE__ */ React.createElement("option", { value: "not_applied_to_invoice" }, " ", "Invoice total excludes QuickPay discount")
      );
    }
  },
  quickpayWouldBeGreaterThanZero: function() {
    return this.quickpayDiscountAmount() > 0;
  },
  quickpayDiscountAmount: function() {
    const adjustedTotal = this.tmsTotal() - this.otherInvoicesAdjustment() - this.otherAdjustment();
    var discountAmount = 0;
    if (adjustedTotal > 0) {
      discountAmount = this.quickpayDiscountPercentage() * adjustedTotal / 100;
      if (this.quickpayDiscountMinimum() > discountAmount) {
        discountAmount = this.quickpayDiscountMinimum();
      }
    }
    return discountAmount;
  },
  otherInvoicesAdjustment: function() {
    if (this.hasOtherInvoiceAdjustments()) {
      return _.chain(this.otherInvoices()).map(this.invoiceAmount).reduce((memo, num) => memo + num, 0).value();
    }
    return 0;
  },
  quickpayDiscountPercentage: function() {
    return quickpayHelper.quickpayPercentage(this.props.carrier);
  },
  quickpayDiscountMinimum: function() {
    return quickpayHelper.quickpayMinimum();
  },
  hasOtherInvoiceAdjustments: function() {
    return this.isDraftStatus() && this.otherInvoices().length > 0;
  },
  isDraftStatus: function() {
    return this.props.carrierInvoice.state === "draft";
  },
  otherInvoices: function() {
    return _.chain(this.props.load.carrier_invoices).filter((ci) => ci.id !== this.props.carrierInvoice.id).filter((ci) => ci.state !== "deleted").filter((ci) => ci.state !== "abandoned").filter((ci) => this.invoiceAmount(ci) > 0).value();
  },
  invoiceAmount: function(invoice) {
    return generalFormatter.cleanAmount(invoice.source_invoice_amount) || 0;
  },
  otherAdjustment: function() {
    if (this.hasAdjustments()) {
      return _.chain(this.adjustments()).pluck("amount").map(parseFloat).reduce((memo, num) => memo + num, 0).value();
    }
    return 0;
  },
  hasAdjustments: function() {
    return !_.isEmpty(this.adjustments());
  },
  adjustments: function() {
    return this.props.load.load.tms_adjustments;
  },
  possiblePossibleAdjustments: function() {
    if (this.props.carrierInvoice.quickpay_disposition === "applied_to_invoice") {
      return /* @__PURE__ */ React.createElement(
        PossibleAdjustments,
        {
          expectedTotal: this.tmsTotal(),
          load: this.props.load,
          carrierInvoice: this.props.carrierInvoice
        }
      );
    }
  },
  quickpayDisposition: function() {
    return this.props.carrierInvoice.quickpay_disposition || "not_quickpay";
  },
  handleQuickpayChange: function(event) {
    let amount;
    if (event.target.value === "not_applied_to_invoice") {
      amount = this.props.carrierInvoice.amount_to_pay || this.props.carrierInvoice.source_invoice_amount;
      let discounted_amount = amount - this.quickpayDiscountAmount();
      if (discounted_amount < 0) {
        discounted_amount = 0;
      }
      this.updateQuickpayRelatedFields(
        true,
        discounted_amount,
        "not_applied_to_invoice"
      );
    } else if (event.target.value === "applied_to_invoice") {
      amount = this.props.carrierInvoice.source_invoice_amount;
      this.updateQuickpayRelatedFields(true, amount, "applied_to_invoice");
    } else {
      amount = this.props.carrierInvoice.source_invoice_amount;
      this.updateQuickpayRelatedFields(false, amount, null);
    }
  },
  handleInvoiceDispositionChange: function(event) {
    if (event.target.value == "original_invoice" || event.target.value == "supplemental_invoice") {
      this.setState({ invoice_disposition: event.target.value }, () => {
        const fields = ["disposition"];
        const values = [this.state.invoice_disposition];
        this.props.invoiceFieldsChanged(fields, values);
      });
    }
  },
  updateQuickpayRelatedFields: function(hasQuickpay, amountToPay, quickpayDisposition) {
    const fields = ["amount_to_pay", "quickpay_disposition", "quickpay"];
    const values = [amountToPay, quickpayDisposition, hasQuickpay];
    this.props.invoiceFieldsChanged(fields, values);
  },
  accountSettings: function() {
    return Api.Account.currentSettings();
  },
  loadLineItemsPresent: function() {
    return this.props.load.load.line_items.length > 0;
  },
  tmsTotal: function() {
    const alwaysUseCarrierCharge = this.accountSettings().always_use_carrier_charge_for_expected_amount;
    const calculationLineItems = lineItemsForCalculation(
      this.props.load.load.line_items,
      this.accountSettings().ignore_adjustment_line_items
    );
    const lineItemsForCarrier = _.select(
      calculationLineItems,
      (lineItem) => this.props.carrierInvoice.carrier_id === lineItem.tms_carrier_id
    );
    if (alwaysUseCarrierCharge || !this.loadLineItemsPresent()) {
      return this.carrierCharge();
    }
    if (lineItemsForCarrier.length > 0) {
      return _.reduce(
        lineItemsForCarrier,
        (memo, lineItem) => {
          return memo + parseFloat(lineItem.total);
        },
        0
      );
    }
    return 0;
  },
  carrierCharge() {
    if (this.props.load.load.carrier_charge) {
      return parseFloat(this.props.load.load.carrier_charge);
    }
    return 0;
  },
  setInvoiceDateToToday: function(e) {
    e.preventDefault();
    const today = moment(/* @__PURE__ */ new Date()).format("YYYY-MM-DD");
    this.setState({ source_invoice_date: today });
    this.props.invoiceFieldChanged("source_invoice_date", today);
    this.props.invoiceChangeComplete();
  },
  invoiceInput: function(field, placeholder, type, ref, hasLeadingText = false) {
    return /* @__PURE__ */ React.createElement(
      ValueLinkTextDroppableInput,
      {
        type,
        ref,
        disabled: this.props.readOnly,
        valueLink: this.myLinkState(field),
        onBlur: this.props.invoiceChangeComplete,
        onKeyPress: this.props.keyPressNotifier(field),
        inputDropped: this.dropTracker(field, this.props.document),
        onDragOver: this.onInvoiceAmountDragOver,
        onDrop: this.onInvoiceAmountDrop,
        placeholder,
        v3ReskinEnabled: this.props.v3ReskinEnabled,
        hasLeadingText
      }
    );
  },
  dropTracker: function(field, document) {
    if (this.props.readOnly) {
      return () => true;
    } else {
      return this.makeDropped(field, document);
    }
  },
  makeDropped: function(field, document) {
    const component = this;
    const tracker = Api.DropTracker.createForDocumentAndField(document, field);
    return (chars, position) => {
      const newState = {};
      let value = chars;
      if (field === "source_invoice_amount") {
        value = generalFormatter.cleanAmount(value);
        if (value === null || value.toString() === "NaN") {
          value = null;
        }
      }
      newState[field] = value;
      component.setState(newState);
      tracker(chars, position);
    };
  },
  onInvoiceAmountDragOver: function(e) {
    e.preventDefault();
  },
  onInvoiceAmountDrop: function(e) {
    if (e.stopPropagation) {
      e.stopPropagation();
    }
    e.preventDefault();
    e.target.value = e.dataTransfer.getData("text/plain");
    e.target.dispatchEvent(new Event("input", { bubbles: true }));
  },
  onInvoiceDateDrop(field) {
    return (e, value) => {
      e.target.value = value || e.target.value;
      this.setState({ [field]: e.target.value });
      this.props.invoiceFieldChanged(field, e.target.value);
      this.props.invoiceChangeComplete();
    };
  },
  dateDroppableInvoiceInput: function(field, placeholder) {
    return /* @__PURE__ */ React.createElement(
      TextDroppableInput,
      {
        type: "date",
        ref: "date",
        disabled: this.props.readOnly,
        valueLink: this.myLinkState(field),
        onDrop: this.onInvoiceDateDrop(field),
        onKeyPress: this.props.keyPressNotifier(field),
        placeholder
      }
    );
  },
  factoringAssignmentBox: function() {
    const factoringAssignment = this.props.factoringAssignment;
    if (factoringAssignment) {
      return /* @__PURE__ */ React.createElement("label", null, /* @__PURE__ */ React.createElement(
        "input",
        {
          type: "checkbox",
          onChange: () => {
            this.props.toggleDocumentData(
              factoringAssignment,
              "actsAsInvoice"
            );
          },
          checked: this.props.factoringAssignment.data.actsAsInvoice
        }
      ), " ", "Factoring Assignment Takes Place of Invoice");
    }
  },
  myLinkState: function(field) {
    const component = this;
    const fields = [
      "source_invoice_number",
      "source_invoice_amount",
      "source_invoice_date"
    ];
    let val = fields.includes(field) ? this.state[field] : this.props[field];
    if (this.props.readOnly) {
      val = this.props[field];
    }
    return {
      value: val,
      requestChange: function(value) {
        var vl;
        if (_.contains(fields, field)) {
          const state = {};
          state[field] = value;
          component.setState(state);
        }
        if (field === "source_invoice_amount") {
          const flds = ["amount_to_pay", "source_invoice_amount"];
          if (value) {
            const fmtd = generalFormatter.cleanAmount(value);
            vl = fmtd ? fmtd.toString() : "0.00";
          } else {
            vl = "0.00";
          }
          let values;
          if (component.props.carrierInvoice.quickpay_disposition === "not_applied_to_invoice") {
            let amountToPay = (vl - component.quickpayDiscountAmount()).toFixed(
              2
            );
            if (amountToPay < 0) {
              amountToPay = 0;
            }
            values = [amountToPay, vl];
          } else {
            values = [vl, vl];
          }
          component.props.invoiceFieldsChanged(flds, values);
        } else {
          component.props.invoiceFieldChanged(field, value);
        }
      }
    };
  },
  possibleExtractedFields() {
    const invoice = this.props.carrierInvoice;
    if (invoice) {
      const visibleExtractedFields = this.visibleExtractedFields();
      const requiredExtractedFields = this.requiredExtractedFields(
        visibleExtractedFields
      );
      return /* @__PURE__ */ React.createElement(
        ExtractedFields,
        {
          sourceId: invoice.id,
          extractedFields: visibleExtractedFields,
          requiredFields: requiredExtractedFields,
          fieldsSourceObject: invoice && invoice.extracted_fields || {},
          renderRows: false,
          fieldContainerClass: "load-detail__document-information-item",
          containerClass: "load-detail__document-information-extracted-fields",
          onChange: this.extractedFieldsChanged
        }
      );
    }
  },
  visibleExtractedFields() {
    const settings = Api.Account.currentSettings() || {};
    const allFields = settings.carrier_invoice_extracted_fields || [];
    const load = this.props.load.load;
    return _.chain(allFields).filter((f) => {
      const strategy = ExtractedFieldVisibility.strategyForField(f);
      return strategy(load);
    }).value();
  },
  requiredExtractedFields(visibleExtractedFields) {
    return _.chain(visibleExtractedFields).filter((field) => field.required === true).pluck("name").value();
  },
  extractedFieldsChanged(updatedFields) {
    this.setState({ extractedFields: updatedFields });
    this.props.invoiceFieldsChanged(["extracted_fields"], [updatedFields]);
  }
});
export default DocumentInformation;
